

const ctcaeRouter = [
  {
    path: '/ctcae',
    name: 'ctcae',
    meta: {
        title: "不良反应评估"
    },
    component: () =>
        import ('@/views/ctcae/chat/index'),
},
{
  path: '/ctcaepatientlist',
  name: 'ctcaepatientlist',
  meta: {
      title: "不良反应评估"
  },
  component: () =>
      import ('@/views/ctcae/ctcaePatientListPage/ctcaePatientListPage'),
},
{
    path: '/ctcaeVideo',
    name: 'ctcaeVideo',
    meta: {
      title: "视频详情"
    },
    component: () =>
        import ('@/views/ctcae/chat/videoDetailPage'),
  },
{
  path: '/ctcaepatientmain',
  name: 'ctcaepatientmain',
  meta: {
      title: "不良反应评估"
  },
  component: () =>
      import ('@/views/ctcae/ctcaePatientMainPage/ctcaePatientMainPage'),
},

]

export default ctcaeRouter